import React from 'react';

import { PublicOfferUserSelectionValues } from '../..';
import { CustomerApplicationModalProps } from '../../../../../../../../../../routes/types';
import { PublicOfferTypes } from '../../../../../../../../../../store/product/external/constants';
import {
  PublicOfferAssetToInvestNormalized,
  PublicOfferDetailsModalityWithTimelineNormalized,
} from '../../../../../../../../../../store/product/types';

import { PublicOfferEquityFields } from './components/PublicOfferEquityFields';
import { PublicOfferFixedFields } from './components/PublicOfferFixedFields';
import { PublicOfferQuantityFields } from './components/PublicOfferQuantityFields';
import { PublicOfferRemunerationFields } from './components/PublicOfferRemunerationFields';

export interface UserSelectionsProps {
  offer: CustomerApplicationModalProps<'publicOffers'>['offer'];
  offerDetails?: PublicOfferAssetToInvestNormalized;
  selectedModality?: PublicOfferDetailsModalityWithTimelineNormalized;
  setUserSelectionValues: React.Dispatch<React.SetStateAction<PublicOfferUserSelectionValues>>;
}

export const UserSelections: React.FC<UserSelectionsProps> = (props) => {
  if (!props.offerDetails || !props.selectedModality) {
    return <></>;
  }

  const correctProps = {
    ...props,
    offerDetails: props.offerDetails,
    selectedModality: props.selectedModality,
  };

  if (props.offer.publicOfferType === PublicOfferTypes.COE_FIXED) {
    return <PublicOfferQuantityFields {...correctProps} />;
  }

  switch (props.offer.limiterCode) {
    case 0:
      return <PublicOfferEquityFields {...correctProps} />;
    case 1:
      return <PublicOfferRemunerationFields {...correctProps} />;
    case 2:
      return <PublicOfferQuantityFields {...correctProps} />;
    case 3:
      return <PublicOfferFixedFields {...correctProps} />;
    default:
      return <></>;
  }
};
